import { render, staticRenderFns } from "./ProjectViewSidebarPriceCard.vue?vue&type=template&id=52dd9a71&scoped=true"
import script from "./ProjectViewSidebarPriceCard.vue?vue&type=script&lang=ts"
export * from "./ProjectViewSidebarPriceCard.vue?vue&type=script&lang=ts"
import style0 from "./ProjectViewSidebarPriceCard.vue?vue&type=style&index=0&id=52dd9a71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dd9a71",
  null
  
)

export default component.exports